/**
 * Trunnion AI - Token Usage Chart
 * Token usage by provider chart using Recharts.
 */

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { useTokenUsageSummary } from '@/hooks/queries/useDashboard';

export function TokenUsageChart() {
  const { data, isLoading } = useTokenUsageSummary('week');

  const chartData = data?.[0]?.breakdown ?? [];

  return (
    <Card padding="none">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Token Usage</CardTitle>
          {data?.[0] && (
            <span className="text-xs text-trunnion-slate-400">
              ${data[0].totalCost.toFixed(2)} total
            </span>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <LoadingSpinner size="sm" />
        ) : chartData.length === 0 ? (
          <p className="text-sm text-trunnion-slate-400 text-center py-4">
            No usage data available
          </p>
        ) : (
          <div className="h-48">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#2D3748" />
                <XAxis
                  dataKey="date"
                  tick={{ fill: '#8D97A6', fontSize: 10 }}
                  axisLine={{ stroke: '#374151' }}
                  tickFormatter={(v: string) => new Date(v).toLocaleDateString('en-US', { weekday: 'short' })}
                />
                <YAxis
                  tick={{ fill: '#8D97A6', fontSize: 10 }}
                  axisLine={{ stroke: '#374151' }}
                  width={60}
                  tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k`}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: '#1A202C',
                    border: '1px solid #374151',
                    borderRadius: '8px',
                    fontSize: '12px',
                  }}
                  labelStyle={{ color: '#FFFFFF' }}
                />
                <Area
                  type="monotone"
                  dataKey="promptTokens"
                  name="Prompt"
                  stackId="1"
                  stroke="#3B82F6"
                  fill="#3B82F6"
                  fillOpacity={0.3}
                />
                <Area
                  type="monotone"
                  dataKey="completionTokens"
                  name="Completion"
                  stackId="1"
                  stroke="#D4A017"
                  fill="#D4A017"
                  fillOpacity={0.3}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
